import { bankIdRetryResponseSchema, bankIdStatusResponseSchema } from '@/api/SE/bankId/schemas';
import { apiRequest } from '@/api/utils/api';

export const getBankIdStatus = (orderId: string) =>
  apiRequest({
    url: `/bankid/${orderId}/status?qr-code=true`,
    method: 'GET',
    schema: bankIdStatusResponseSchema,
  });

export const retryBankId = (orderId: string) =>
  apiRequest({ url: `/bankid/${orderId}/retry`, method: 'POST', schema: bankIdRetryResponseSchema });
